import { AuthProvider } from './components/auth-provider'
import AuthButton from './components/auth-button'
import {
  EmotionThemeProvider,
  ThemeProvider,
  theme,
} from '@yuno/design-system-web'
import { BrowserRouter, useRoutes } from 'react-router-dom'
import { EmailVerificationAuth } from './components/email-verification.ts'
import { ApiProvider } from '@yuno/dashboard-api-mfe'
import { MainLayout } from './layouts/main-layout'
import { Logout } from './components/auth-logout'

const Root = () => {
  const mainRoutes = {
    path: '/auth',
    element: <MainLayout />,
    children: [
      {
        path: '/auth',
        element: (
          <AuthProvider>
            <AuthButton />
          </AuthProvider>
        ),
      },
      {
        path: '/auth/emailverify',
        element: (
          <ApiProvider>
            <EmailVerificationAuth />
          </ApiProvider>
        ),
      },
      {
        path: '/auth/logout',
        element: (
          <AuthProvider>
            <Logout />
          </AuthProvider>
        ),
      },
    ],
  }

  const Routing = () => {
    const routing = useRoutes([mainRoutes])
    return <>{routing}</>
  }

  return (
    <EmotionThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routing />
        </BrowserRouter>
      </ThemeProvider>
    </EmotionThemeProvider>
  )
}

export default Root
